import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import './Login.css';
import { FaArrowLeft } from 'react-icons/fa';
import API_BASE_URL from './config';

const GOOGLE_CLIENT_ID = '419499731991-32au01h15f7o8jltocivs4hdhlts6pis.apps.googleusercontent.com';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const location = useLocation();
  const fromGold = new URLSearchParams(location.search).get('from') === 'gold';


  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      if (response.ok) {
        localStorage.setItem('userId', data.user.userId);
        localStorage.setItem('userSource', 'user_signup_details');
        localStorage.setItem('user_email', email);
        navigate(fromGold ? '/gold-dashboard' : '/dashboard');
      } else {
        alert(data.error || 'Login failed.');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('An error occurred during login.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async (credentialResponse) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/google`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: credentialResponse.credential }),
      });
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem('userId', data.user.userId);
        localStorage.setItem('userSource', 'users');
        localStorage.setItem('user_email', data.user.email);
        navigate(fromGold ? '/gold-dashboard' : '/dashboard');
      } else {
        alert('Google login failed.');
      }
    } catch (error) {
      console.error('Google login error:', error);
      alert('An error occurred during login.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-header">
          <button className="back-btn" onClick={() => navigate('/')} disabled={loading}>
            <FaArrowLeft />
          </button>
          <h2>Sign In to DiscountDost</h2>
        </div>
        <form onSubmit={handleEmailLogin}>
          <label>Email Address</label>
          <input
            type="email"
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          <button type="submit" disabled={loading}>
            {loading ? 'Processing...' : 'Continue with Email'}
          </button>
        </form>
        <div className="google-login">
          <GoogleLogin
            clientId={GOOGLE_CLIENT_ID}
            onSuccess={handleGoogleLogin}
            onError={() => {
              alert('Google login failed.');
              setLoading(false);
            }}
          />
        </div>
        <div className="signup-redirect">
          <p>Don't have an account? <span onClick={() => navigate('/signup')}>Sign Up</span></p>
        </div>
      </div>
    </div>
  );
};

export default Login;